module.exports = __webpack_public_path__ + "static/media/blog8.2eba236c.png";